// test367
(367 && 0);
